import { Platform, DarePlatform } from 'root/src/shared/@types/platforms';
import { isPlatform } from 'root/src/shared/platforms/guards/platform.guards';
export function getDarePlatforms(dare) {
    const darePlatform = dare.platform;
    if (!darePlatform || darePlatform === DarePlatform.Any) {
        return [Platform.Twitch, Platform.YouTube, Platform.TikTok];
    }
    if (isPlatform(darePlatform)) {
        return [darePlatform];
    }
    return [];
}
/**
 * Get the platforms that the dares are available on.
 * @param dares
 */
export function getDropDarePlatforms(dares) {
    const platformSet = dares.reduce((acc, dare) => {
        if (dare.disabled) {
            return acc;
        }
        const darePlatform = getDarePlatforms(dare);
        darePlatform.forEach(platform => acc.add(platform));
        return acc;
    }, new Set());
    return Array.from(platformSet);
}
/**
 * Get the difficulty levels of the dares.
 * @param dares
 */
export function getDropDareDifficultyLevels(dares) {
    const difficultySet = dares.reduce((acc, dare) => {
        acc.add(dare.level);
        return acc;
    }, new Set());
    return Array.from(difficultySet);
}
/**
 * Get the battle pass ids of the dares.
 * @param dares
 */
export function getDropDareBattlePassIds(dares) {
    const battlePassIds = dares.reduce((acc, dare) => {
        if (dare.battlePass) {
            acc.add(dare.battlePass.id);
        }
        return acc;
    }, new Set());
    return Array.from(battlePassIds);
}
